import { Box } from "@mui/material";
import {
  CopyTableToClipboard,
  CopyTableToClipboardProps,
} from "~/components/copy-table-to-clipboard";
import { useAssetSoftwareFilterContext } from "~/pages/inventory/asset/useAssetSoftwareFilterContext";
import { FilterList } from "@mui/icons-material";

type AssetSoftwareFilterSection = {
  filterContext: ReturnType<typeof useAssetSoftwareFilterContext>;
  showCopyToClipboard: boolean;
  tableData: CopyTableToClipboardProps["tableData"];
};

export const AssetSoftwareFilterSection = ({
  filterContext,
  showCopyToClipboard,
  tableData,
}: AssetSoftwareFilterSection) => {
  const { filterBar, quickFilterBar, activeFilterBar } = filterContext;
  return (
    <Box display="flex" gap={2} mt={3}>
      <Box flex="1">
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box flex="1" alignItems="center">
              {filterBar}
            </Box>
            {showCopyToClipboard && (
              <CopyTableToClipboard
                tableData={tableData}
                sx={{ display: "flex", alignItems: "center" }}
              />
            )}
          </Box>
          <Box sx={{ width: "100%", display: "flex", columnGap: 2, rowGap: 1 }}>
            <Box sx={{ display: "flex", fontWeight: 700, gap: 1, py: 0.75 }}>
              <FilterList />
              Filters
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                width: "100%",
              }}
            >
              {quickFilterBar}

              {activeFilterBar}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
